import EthereumService from '@/services/ethereum'
import { findTokenFromAddr } from '@/utils/token'
import bignumber from '@/utils/bignumber'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapDex = options.kulapDex
    this.kulapApi = options.kulapApi
  }

  async getCurentNetwork () {
    return this.kulapDex.getCurrentNetworkConnected()
  }

  async getTradeHistory (userAddress, currentNetwork) {
    let fromBlockHeight = await this.kulapDex.getLatestBlockNumber()
    const toBlockNumber = 'latest'
    const latestScanedBlock = localStorage.getItem(`KULAP.noti-latest-block-height-${currentNetwork}-${userAddress}`)
    const cacheTxsHistory = JSON.parse(localStorage.getItem(`KULAP.transaction-history-${currentNetwork}-${userAddress}`))
    if (latestScanedBlock) {
      fromBlockHeight = latestScanedBlock
    }
    const events = await this.kulapDex.getPastEvents('Trade', { 'trader': userAddress }, fromBlockHeight, toBlockNumber)
    let newEvents = [] // newEvents will only have success transactions.
    let promiseTasks = []
    events.forEach(async (e) => {
      const task = new Promise(async (resolve) => {
        const event = await this.mapTradingHistory(currentNetwork, e, 'success')
        newEvents.push(event)
        resolve()
      })
      promiseTasks.push(task)
    })
    await Promise.all(promiseTasks)
    if (cacheTxsHistory && cacheTxsHistory.length) {
      newEvents.forEach((e) => {
        const indexOfCacheTxHistory = cacheTxsHistory.findIndex(c => c.transactionHash === e.transactionHash)
        if (indexOfCacheTxHistory === -1) { // Not found
          cacheTxsHistory.push(e)
        } else { // Found
          cacheTxsHistory[indexOfCacheTxHistory] = e
        }
      })
      if (cacheTxsHistory.length > 200) {
        cacheTxsHistory.slice(cacheTxsHistory.length - 200)
      }
      this.store.dispatch('setTransactionHistory', cacheTxsHistory)
      // mamipulate pending transaction.
      const cachePendingTxs = cacheTxsHistory.filter(tx => tx.status === 'in progress')
      if (cachePendingTxs.length) {
        this.intervalCheckStatusPendingTx(cachePendingTxs, userAddress, currentNetwork)
      }
    } else {
      this.store.dispatch('setTransactionHistory', newEvents)
    }
  }

  async intervalCheckStatusPendingTx (cachePendingTxs, userAddress, currentNetwork) {
    const txsHistory = JSON.parse(localStorage.getItem(`KULAP.transaction-history-${currentNetwork}-${userAddress}`))
    cachePendingTxs.forEach(tx => {
      this.updatePendingTransactionStatus(tx.transactionHash, txsHistory)
    })
  }

  async updatePendingTransactionStatus (hash, txsHistory) {
    const txHistory = txsHistory.find((txHis) => txHis.transactionHash === hash)
    if (txHistory) {
      setTimeout(async () => {
        const tx = await this.getTransactionReceipt(hash)
        if (tx && tx.status) {
          txHistory.status = 'success'
          this.store.dispatch('pushTransactionHistory', txHistory)
        } else if (tx && !tx.status) {
          txHistory.status = 'fail'
          this.store.dispatch('pushTransactionHistory', txHistory)
        } else {
          await this.updatePendingTransactionStatus(hash, txsHistory)
        }
      }, 10000)
    }
  }

  async mapTradingHistory (network, event, status) {
    const { timestamp } = await this.getBlockDetail(event.blockNumber)
    const fromAsset = findTokenFromAddr(network, event.returnValues[0])
    const toAsset = findTokenFromAddr(network, event.returnValues[2])
    return {
      transactionHash: event.transactionHash,
      fromAmount: bignumber(event.returnValues.srcAmount).toBase(fromAsset.decimal),
      toAmount: bignumber(event.returnValues.destAmount).toBase(toAsset.decimal),
      blockNumber: event.blockNumber,
      fromAsset,
      toAsset,
      timestamp,
      status
    }
  }

  setUnreadTxHistoryAmount (amount, userDefaultWallet, currentNetwork) {
    this.store.dispatch('setUnreadTxHistoryAmount', amount)
    localStorage.setItem(`KULAP.unread-tx-history-amount-${currentNetwork}-${userDefaultWallet}`, amount)
  }

  setUnreadUserNotiAmount (amount, userId) {
    this.store.dispatch('setUnreadUserNotiAmount', amount)
    localStorage.setItem(`KULAP.unread-user-noti-amount-${userId}`, amount)
  }

  markTxHistoryAsUnread (unread) {
    this.store.dispatch('markTxHistoryAsUnread', unread)
  }

  markUserNotificationAsRead (timestamp) {
    return this.kulapApi.putUpdateUserNotificationAsRead(timestamp)
  }
}



// WEBPACK FOOTER //
// ./src/features/Notification/service.js